export const SHOWCASE_STATUS_ID_DRAFT = 1;
export const SHOWCASE_STATUS_ID_AGREEMENT = 2;
export const SHOWCASE_STATUS_ID_PUBLISHED = 3;
export const SHOWCASE_STATUS_ID_REJECTED = 4;
export const SHOWCASE_STATUS_ID_REMOVED = 5;
export const SHOWCASE_STATUS_ID_REVISION = 6;

export const SHOWCASE_STATUS_DRAFT = 'draft';
export const SHOWCASE_STATUS_AGREEMENT = 'agreement';
export const SHOWCASE_STATUS_PUBLISHED = 'published';
export const SHOWCASE_STATUS_REJECTED = 'rejected';
export const SHOWCASE_STATUS_REMOVED = 'removed';
export const SHOWCASE_STATUS_REVISION = 'revision';

export const SHOWCASE_PUBLIC_STATUS_LOOKING_FOR_PARTNER =
  'is_looking_for_partner';
export const SHOWCASE_PUBLIC_STATUS_LOOKING_FOR_PERFORMER =
  'is_looking_for_performer';
export const SHOWCASE_PUBLIC_STATUS_LOOKING_FOR_STUDENT =
  'is_looking_for_student';
export const SHOWCASE_PUBLIC_STATUS_WAITING_FOR_OTHER = 'is_waiting_for_other';

export function getPublicStatuses(showcase) {
  const statuses = [];
  if (showcase && showcase.isLookingForPartner) {
    statuses.push({
      type: SHOWCASE_PUBLIC_STATUS_LOOKING_FOR_PARTNER,
      text: 'Приглашаем партнеров',
    });
  }
  if (showcase && showcase.isLookingForPerformer) {
    statuses.push({
      type: SHOWCASE_PUBLIC_STATUS_LOOKING_FOR_PERFORMER,
      text: 'Ищем исполнителей',
    });
  }
  if (showcase && showcase.isLookingForStudent) {
    statuses.push({
      type: SHOWCASE_PUBLIC_STATUS_LOOKING_FOR_STUDENT,
      text: 'Приглашаем студентов',
    });
  }
  if (showcase && showcase.isWaiting) {
    statuses.push({
      type: SHOWCASE_PUBLIC_STATUS_WAITING_FOR_OTHER,
      text: 'Выполним похожий проект',
    });
  }
  return statuses;
}
